<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .cons{
    display: none;
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-around;
    li{
      width: 190px;
      height: 188px;
      //margin-right:100px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .required{
    font-size: 16px;
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  //.effect-lists li{
  //  margin-right: 62px;
  //  float: left;
  //}
  //.effect-lists1 li{
  //  margin-right: 40px!important;
  //  float: left;
  //}
  //.effect-lists li:last-child{
  //  margin-right: 0;
  //}
  .effect-lists1 li img{
    width: 55%;
  }
  .effect-lists1 li:hover{
    background: url("../../assets/img/设备及原料/化学试剂/xuan.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
  }
  .effect-lists1 li:nth-last-child(1) img{
    width: 55% !important;
  }
  .effect-lists1 li:nth-last-child(2) img{
    width: 55% !important;
  }
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .effect-lists1 li:hover{
      background: #fff!important;
    }
    .effect-lists1{
      justify-content: flex-start!important;
    }
    .container100{
      margin-bottom: 20px!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/设备及原料/化学试剂/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/一级标题Banner/化学试剂.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">核酸药物是各种具有不同功能的寡聚核糖核苷酸(RNA)或寡聚脱氧核糖核苷酸(DNA)，可以直接作用于致病靶基因或者靶mRNA，在基因水平上进行精准医疗，具有小分子药物、抗体药物等不具备的多种优势。包括信使RNA(mRNA)、反义核酸(ASO)、小干扰RNA(siRNA)、小激活RNA(saRNA)、微小RNA(miRNA)、适配体(aptamer)、核酶(ribozyme)等。核酸药物的本质是DNA或RNA分子，可通过核酸修饰来提高稳定性、提高靶细胞结合率等。</p>
      <p class="desc">擎科生物专注于核酸药物原料研究，凭借先进的研发能力，自主研发了DNA合成试剂，合成单体，修饰单体与CPG，条状分子筛，合成柱等一系列产品，拥有从引物合成原材料，DNA合成仪制造到引物合成纯化新工艺的核酸全产业链优势，助力核酸药物的开发生产。高标准的核酸合成产品不仅满足用户在基因组学研究、疾病检测和药物开发等应用方面的需求，同时可广泛应用于实验室及批量生产规模的DNA/RNA合成。</p>
        <div class="con">
          <ul class="effect-lists1 effect-lists" style="margin-top: 20px;">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active2: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1">
              <a :href="item.ref" target="_blank" style="color: #333">
                <img :src="`/static/img/h_${item.img}${currentService===index ? '' : ''}.png`" style="margin-top: 0;">
                <p style="margin-top: 10px;" >{{item.label}}</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class="effect-lists1 effect-lists" style="margin-top: 20px;">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @mouseout="currentService = -1">
              <a :href="item.ref" target="_blank" style="color: #333">
                <img :src="`/static/img/h_${item.img}${currentService===index ? '' : ''}.png`" style="margin-top: 0;">
                <p style="margin-top: 10px;" >{{item.label}}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">擎科化学产品优势<small>Advantages of Tsingke chemical products</small></div>
          <div class="con">
            <div class="neirong" style="display: flex">
              <div class="left ">
                <img src="@/assets/img/设备及原料/化学试剂/ys.png" class="img-fluid">
              </div>
              <div class="right">
                <div class="required">
                  <p class="mb20">1.自主研发生产200多种核酸合成原材料及耗材，合成原料年产量高达200吨；</p>
                  <p class="mb20">2.通过ISO9001管理体系认证，特殊化学工艺，严格质控，确保优质的合成效率，满足批量生产要求；</p>
                  <p class="mb20">3.自主研发生产“可控孔径玻璃珠（CPG）”，突破国外“卡脖子”技术；</p>
                  <p class="mb20">4.市场占有率超过35%，出口韩国、美国及泰国等多个国家和地区。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cons">
            <div class="neirong" style="display: flex">
              <div class="right">
                <div class="required">
                  <p class="mb20">1.自主研发生产200多种核酸合成原材料及耗材，合成原料年产量高达200吨；</p>
                  <p class="mb20">2.通过ISO9001管理体系认证，特殊化学工艺，严格质控，确保优质的合成效率，满足批量生产要求；</p>
                  <p class="mb20">3.自主研发生产“可控孔径玻璃珠（CPG）”，突破国外“卡脖子”技术；</p>
                  <p class="mb20">4.市场占有率超过35%，出口韩国、美国及泰国等多个国家和地区。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`" >
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class=" service_chan" style="justify-content: flex-start!important;">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <div class="gene_img2"><img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 50px;height: 55px;"></div>
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {label: '合成试剂', img: '1', ref:'http://www.dnachem.com/?dnasynthesis2/id/20.html'},
        {label: '合成单体', img: '2', ref:'http://www.dnachem.com/?dnapcr1/id/16.html'},
        {label: '修饰单体＆CPG', img: '3', ref:'http://www.dnachem.com/?dnahc/id/15.html'},
        {label: '合成柱', img: '4', ref:'http://www.dnachem.com/?dnahc1/id/8.html'},
        {label: '分子筛', img: '5', ref:'http://www.dnachem.com/?dnahc1/id/222.html'}
        ],
      gene1: [
        {name: '基因合成',img: '1', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '2',ref: '/tec/compose'},
        {name: '修饰合成',img: '3', ref: '/equipment/Modified_synthesis'},
        // {name: '分子试剂',img: '4', ref: '/equipment/Molecular_reagent'},
        {name: '常规分子项目' ,img: '5',ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/equipment/Chemical_Reagents.vue